module.exports = __webpack_public_path__ + "img/SAN.c70a4202.svg";